import { render, staticRenderFns } from "./AlertPopup.vue?vue&type=template&id=2961b758&scoped=true"
import script from "./AlertPopup.vue?vue&type=script&lang=js"
export * from "./AlertPopup.vue?vue&type=script&lang=js"
import style0 from "./AlertPopup.vue?vue&type=style&index=0&id=2961b758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2961b758",
  null
  
)

export default component.exports